"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ = require("./..");
var _styles = require("../../styles");
var _fa = require("react-icons/fa");
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _DialogContentText = _interopRequireDefault(require("@mui/material/DialogContentText"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _Switch = _interopRequireDefault(require("@mui/material/Switch"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CookieSettings = () => {
  const theme = (0, _styles.useTheme)();
  const [open, setOpen] = (0, _react.useState)(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleAccept = () => {
    setOpen(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Button, {
      variant: "outlined",
      color: "primary",
      "aria-label": "Cookie Preferences",
      title: "Cookie Preferences",
      onClick: handleClickOpen,
      sx: {
        borderRadius: 2,
        minWidth: 'auto',
        width: '30px',
        height: '30px',
        padding: 0.5,
        borderColor: (0, _styles.alpha)(theme.palette.divider, 0.2)
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fa.FaCookieBite, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog.default, {
      open: open,
      onClose: handleClose,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogTitle.default, {
        children: "Cookie Preferences"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogContent.default, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogContentText.default, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
            children: "Please note:"
          }), " \"Required cookies\" are just that - required. Disabling these cookies would have adverse effects on this site.  For additional information see", /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Link, {
            underline: "none",
            component: "a",
            href: "/docs/required-cookies",
            color: "text.primary",
            marginLeft: 1,
            children: "What are the required cookies for this site?"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormGroup.default, {
          sx: {
            paddingTop: '40px'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
            disabled: true,
            control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch.default, {
              defaultChecked: true
            }),
            label: "Required cookies"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
            control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch.default, {
              defaultChecked: true
            }),
            label: "Performance cookies"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
            control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch.default, {
              defaultChecked: true
            }),
            label: "Personalization cookies"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
            control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Switch.default, {}),
            label: "Third party cookies"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogActions.default, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Button, {
          onClick: handleClose,
          children: "Cancel"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Button, {
          onClick: handleAccept,
          children: "Accept"
        })]
      })]
    })]
  });
};
CookieSettings.propTypes = {};
var _default = exports.default = CookieSettings;